import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// const home = () => import('../view/home')
// const main = () => import('../view/main')
//

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

export const constantRoutes = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/view/login')
    },
    {
        path: '/main',
        name: 'main',
        component: () => import('@/view/main'),
        children:[
            {
                path:'home',
                name:'homePage',
                component: () => import('@/view/home'),
            },
            {
                path:'sysUser',
                name:'sysUser',
                component: () => import('@/view/modules/sys/sysUser'),
            },
            {
                path:'sysRole',
                name:'sysRole',
                component: () => import('@/view/modules/sys/sysRole'),
            },
            {
                path:'feedBackAdmin',
                name:'feedBackAdmin',
                component: () => import('@/view/modules/sys/feedBackAdmin'),
            },
            {
                path:'information',
                name:'information',
                component: () => import('@/view/modules/information/information'),
            },
            {
                path:'processes',
                name:'processes',
                component: () => import('@/view/modules/processes/processes'),
            },
            {
                path:'examine',
                name:'examine',
                component: () => import('@/view/modules/examine/examine'),
            },
            {
                path:'feedBack',
                name:'feedBack',
                component: () => import('@/view/feedBack'),
            },
            {
                path:'autoReview',
                name:'autoReview',
                component: () => import('@/view/modules/autoReview/autoReview'),
            },
            {
                path:'department',
                name:'department',
                component: () => import('@/view/modules/department/department'),
            },
        ]
    }

]
const createRouter = () =>
    new Router({
        mode: 'history',
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes
    })

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router


// let router = new VueRouter({
//     // base: '/apsp-web/',
//     mode:"history",
//     routes: [
//         {path: '/', name: 'index', component:() => import('../view/login')},
//         {path: '/main', name: 'main',component:main,
//             children:[
//                 {path:'',name:'home',component:home}]},
//     ]
// })
//
// export default router
